import { InteractionEvent } from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';

export function trackContactRequestEmailVerificationVirtualPageView(language: string) {
  trackEventHarmonized(InteractionEvent.VIRTUAL_PAGEVIEW, {
    h_page_type_110: 'lead_verification',
    h_page_subtype_112: 'landingpage',
    h_content_language_116: language,
  });
}

export function trackContactRequestEmailVerificationConfirmation(contactRequestId: string): void {
  trackEventHarmonized(InteractionEvent.SUBMIT_FORM_LEAD_VERIFIED, {
    h_event_action_007: 'contact_form',
    h_event_label_008: 'sendMessage_ok',
    h_lead_id_066: contactRequestId,
  });
}
